import {translater} from './translate';

export default {
	namespaced: true,
	state: {
		message: undefined
	},

	actions: {
		setMessage(context, payload)
		{
			context.commit('setMessage', payload);
		}
	},

	mutations: {
		setMessage(state, payload)
		{
			state.message = payload;
		}
	},

	getters: {
		message(state)
		{
			return state.message;
		},

		hasMessage(state)
		{

			return typeof state.message !== 'undefined';
		}
	}
}
